import React from 'react';
import { MessageCircle } from 'lucide-react';
import { getWhatsAppLink } from '../config/contact';
interface WhatsAppButtonProps {
  text?: string;
  className?: string;
  message?: string;
  size?: 'sm' | 'md' | 'lg';
}
export function WhatsAppButton({
  text = 'Get a free quote now',
  className = '',
  message,
  size = 'md'
}: WhatsAppButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-lg transition-colors duration-200 bg-green-600 hover:bg-green-700 text-white shadow-sm hover:shadow-md';
  const sizeStyles = {
    sm: 'px-4 py-2 text-sm gap-2',
    md: 'px-6 py-3 text-base gap-2',
    lg: 'px-8 py-4 text-lg gap-3'
  };
  return <a href={getWhatsAppLink(message)} target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${sizeStyles[size]} ${className}`} data-id="element-157">
      <MessageCircle className={size === 'lg' ? 'w-6 h-6' : 'w-5 h-5'} data-id="element-158" />
      {text}
    </a>;
}